import React from 'react';

const linkClass = "link-secondary link-underline-opacity-0 link-underline-opacity-75-hover";

function Footer() {
    return (
        <footer className="footer mt-auto py-3 bg-body-tertiary">
            <div className="container-lg d-flex flex-column flex-sm-row justify-content-center align-items-center gap-3 ">
                <a href="mailto:iamvkosarev@gmail.com" className={linkClass}>
                    iamvkosarev@gmail.com
                </a>
                <a href="https://t.me/iamvkosarev" target="_blank" className={linkClass} rel="noreferrer">
                    Telegram
                </a>
                <a href="https://www.linkedin.com/in/iamvkosarev/" target="_blank" className={linkClass} rel="noreferrer">
                    LinkedIn
                </a>
                <a href="https://github.com/iamvkosarev" className={linkClass} target="_blank" rel="noreferrer">
                    GitHub
                </a>
            </div>
        </footer>
    );
}

export default Footer;